export default __webpack_public_path__ + "static/media/04.5f33c3dd.svg";